import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { oneOf } from 'prop-types';
import React from 'react';
import { agentHue, isAgentFloor, userHue, VOICE_PHASES } from './constants';

const HEIGHT = 150;

// Inline SVG fractal noise used as a faint grain overlay.
const GRAIN_SVG = `data:image/svg+xml;utf8,${encodeURIComponent(
  "<svg xmlns='http://www.w3.org/2000/svg' width='160' height='160'>" +
    "<filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.8' numOctaves='2' stitchTiles='stitch'/></filter>" +
    "<rect width='160' height='160' filter='url(#n)' opacity='0.6'/></svg>",
)}`;

const TOP_FADE_MASK =
  'linear-gradient(to top, #000 0%, #000 14%, rgba(0,0,0,0.55) 48%, transparent 96%)';

const Root = styled(Box)({
  position: 'relative',
  width: '100%',
  height: HEIGHT,
  overflow: 'hidden',
  pointerEvents: 'none',
  WebkitMaskImage: TOP_FADE_MASK,
  maskImage: TOP_FADE_MASK,
});

const Focus = styled(Box)({
  position: 'absolute',
  bottom: -(HEIGHT * 0.46),
  left: '50%',
  height: HEIGHT,
  transformOrigin: 'bottom center',
  transform: 'translateX(-50%) scaleY(calc(0.72 + var(--vc-level, 0) * 0.5))',
  transition: 'background .6s ease',
  pointerEvents: 'none',
});

const FocusTint = styled(Focus)({
  width: 1040,
  filter: 'blur(48px)',
  opacity: 'calc((0.12 + var(--vc-level, 0) * 0.5) * 1)',
});

const FocusUser = styled(Focus)({
  width: 600,
  filter: 'blur(38px)',
  opacity: 'calc((0.12 + var(--vc-level, 0) * 0.5) * 0.7)',
});

const FocusAgent = styled(Focus)({
  width: 600,
  filter: 'blur(40px)',
  opacity: 'calc((0.12 + var(--vc-level, 0) * 0.5) * 0.7)',
});

const Grain = styled(Box)({
  position: 'absolute',
  inset: 0,
  backgroundImage: `url("${GRAIN_SVG}")`,
  backgroundSize: '160px 160px',
  mixBlendMode: 'screen',
  opacity: 'calc(0.05 + var(--vc-level, 0) * 0.07)',
  pointerEvents: 'none',
});

const Bloom = ({ phase = 'listening' }) => {
  const tintTheme = theme => (isAgentFloor(phase) ? agentHue(theme) : userHue(theme));

  return (
    <Root aria-hidden="true">
      <FocusTint
        sx={theme => ({
          background: `radial-gradient(50% 62% at 50% 100%, ${tintTheme(theme)}, transparent 72%)`,
        })}
      />
      <FocusUser
        sx={theme => ({
          background: `radial-gradient(50% 62% at 50% 100%, ${userHue(theme)}, transparent 72%)`,
        })}
      />
      <FocusAgent
        sx={theme => ({
          background: `radial-gradient(50% 62% at 50% 100%, ${agentHue(theme)}, transparent 72%)`,
        })}
      />
      <Grain />
    </Root>
  );
};

Bloom.propTypes = {
  phase: oneOf(VOICE_PHASES),
};

export default Bloom;
